var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./DeleteAccount.js"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler?id=data-v-58095bf5!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./DeleteAccount.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/Account/DeleteAccount.vue
// module id = 570
// module chunks = 0